import { KettleAlertOutlineIcon } from './KettleAlertOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 4F1F1AC0-68D1-4C74-8F03-DF6EBC2C8B29
 * name kettle-alert-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/kettle-alert-outline.svg
 * tags
 * - Home Automation 
 * - Alert / Error 
 * - Food / Drink 
 */
export const KettleEmptyAlertIcon = KettleAlertOutlineIcon;
export default KettleEmptyAlertIcon